export default __webpack_public_path__ + "static/KFZapp_2-d1a9d856a40e75917e64e2059767d7b4.png";